import * as React from "react";

const Headline = ({children}) => {
    return (
        <h2 className="text-lg font-medium text-gray-900">{children}</h2>
    );
};

export default Headline;
